import script from "./LobbyRoom.vue?vue&type=script&setup=true&lang=ts"
export * from "./LobbyRoom.vue?vue&type=script&setup=true&lang=ts"

import "./LobbyRoom.vue?vue&type=style&index=0&id=b5cad72e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5cad72e"]])

export default __exports__